import { EventFragment } from "../../../../__generated__/graphql";
import { cn } from "../../../../lib/utils";
import { useCalendar } from "../../context/hook";

interface EventItemProps {
  event: EventFragment;
}

export default function EventItem({ event }: EventItemProps) {
  const { selectedEvent, setSelectedEvent } = useCalendar();

  /* TODO: Some activities can be on multiple days, or different days than the main event */
  /* TODO: Some activities can have no event */
  return (
    <div className="flex flex-col">
      <div
        className={cn(
          "flex items-center justify-between px-1 rounded-xs bg-input truncate border border-border cursor-pointer hover:bg-card",
          selectedEvent?.id === event.id && "bg-accent/20"
        )}
        onClick={() => setSelectedEvent(event)}
      >
        <div
          className={cn(
            "text-white text-sm truncate  cursor-pointer hover:bg-card hover:text-accent transition-all duration-300"
          )}
        >
          {event.name}
        </div>
      </div>
    </div>
  );
}
